if ($(".course-tabs").length > 0) {
  const positionTabs = $(".course-tabs").offset().top;
  $(window).on("scroll", function () {
    if ($(window).scrollTop() >= positionTabs) {
      $(".course-tabs").addClass("fixed");
    } else {
      $(".course-tabs").removeClass("fixed");
    }
  });
}
